import { Breakpoints } from '@volkswagen-onehub/components-core';
import styled, { css } from 'styled-components';

import { cssFadeIn, cssScrollbarHidden } from './styles';
import { TabsButtonsVariant } from './Tabs';

const getTabButtonLinearGradient = (isPrevious: boolean, variant?: TabsButtonsVariant) => css`
  // background-image: linear-gradient(
  //   ${isPrevious ? 'to right' : 'to left'},
  //   rgb(255, 255, 255) ${variant === TabsButtonsVariant.Images ? 0 : '75%'},
  //   rgba(255, 255, 255, 0)
  // );
`;

const getTabButtonPositioning = (
  isPrevious: boolean,
  variant?: TabsButtonsVariant,
) => {

  let distance;
  switch (variant) {
    case TabsButtonsVariant.DetailedSpecs:
      distance = 100;
      break;
    case TabsButtonsVariant.Images:
    case TabsButtonsVariant.Default:
    default:
      distance = 0;
      break;
  }

  return css`
    left: ${isPrevious && distance};
    right: ${!isPrevious && distance};
  `;
};

// * D6-Tabs doesn't support buttons to navigate
export const PolyfillTabsButtonsContainer = styled.div<{ variant: TabsButtonsVariant }>`
  position: relative;
  display: grid;
  z-index: 0;
  grid-row-gap: 16px;

  [class^='StyledTabBar-'] {
    margin: 0;
    -webkit-overflow-scrolling: touch;

    ${cssScrollbarHidden}

    ${({ variant, theme }) =>
      variant === TabsButtonsVariant.DetailedSpecs &&
      css`
    [class^='StyledTabAnchor-'] {
      padding-top: ${theme.size.static250}

      [class^='StyledTextComponent-'] {
        font-size: ${({ theme }) => theme.fonts.label[150].fontSize};
        line-height: ${({ theme }) => theme.fonts.label[150].lineHeight};
        margin: 0;
      }
    `}
  }
`;

export enum ArrowsDirection {
  Previous = 'previous',
  Next = 'next',
}

type PolyfillTabsButtonsEdgeProps = {
  direction: ArrowsDirection;
  variant?: TabsButtonsVariant;
};

export const PolyfillTabsButtonsEdge = styled.div<PolyfillTabsButtonsEdgeProps>`
  --width-edge: 40px;
  --width-space: 10px;

  position: absolute;
  bottom: 2px;
  display: flex;
  z-index: 1;

  pointer-events: none;
  > * {
    pointer-events: initial;
  }

  ${({ variant, theme }) => {
    const topPosition = variant === TabsButtonsVariant.DetailedSpecs ? theme.size.static200 : '-2px';
    return variant === 'images'
      ? css`
          top: 0;
          align-items: center;
          height: ${theme.size.static510};
          width: ${theme.size.grid004};

          @media (min-width: ${Breakpoints.b960}px) {
            height: ${theme.size.static530};
            width: ${theme.size.grid002};
          }
        `
      : css`
          top: ${topPosition};
          align-items: start;
          width: var(--width-edge);
        `
  }}

  @media (min-width: ${Breakpoints.b1600}px) {
    padding-top: ${({ theme }) => theme.size.static100};
  }

  ${cssFadeIn}

  ${({ direction, variant }) => {
    const isPrevious = direction === ArrowsDirection.Previous;

    return css`
      justify-content: ${isPrevious ? 'flex-start' : 'flex-end'};
      ${getTabButtonPositioning(isPrevious, variant)};
      ${variant !== TabsButtonsVariant.DetailedSpecs &&
      getTabButtonLinearGradient(isPrevious, variant)}
    `;
  }}
`;
